import Input from 'components/Input'
import { InputFieldTypes } from 'components/Input/types'
import React, { useEffect, useState } from 'react'
import { CurrentFilterType, OnChangeCurrentFilterValueFunction } from './redux/types'

type DateInputWrapperProps = {
  id: string
  currentFilter: CurrentFilterType
  onChangeCurrentFilterValue: OnChangeCurrentFilterValueFunction
}

export default function DateInputWrapper({ id, currentFilter, onChangeCurrentFilterValue }: DateInputWrapperProps) {
  const initialDateValue = { start: currentFilter.value.start || '', end: currentFilter.value.end || '' }
  const [date, setDate] = useState(initialDateValue)

  useEffect(() => {
    if(date.start && date.end) {
      onChangeCurrentFilterValue(id, date)
    }
  }, [date.start, date.end])

  return (
    <Input
      type={InputFieldTypes.datePicker}
      value={{ 
        start: date.start,
        end: date.end,
      }}
      setValue={setDate}
      calendarYearRange={currentFilter.type.calendarYearRange}
    />
  )
}
